export default __webpack_public_path__ + "static/media/redDot.fc851458.svg";